import { useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BRAND_BLUE_DARK } from "../theme/appTheme";
import { useTranslation } from "../i18n/LanguageContext";
import { useNewVersionAvailable } from "../Services/versionCheck";

// Small bottom bar shown once a newer portal version is deployed. Reloading is
// always the user's choice; closing hides it for the rest of this tab's life.
function UpdateBanner() {
  const { t } = useTranslation();
  const available = useNewVersionAvailable();
  const [dismissed, setDismissed] = useState(false);

  if (!available || dismissed) return null;

  return (
    <Box
      role="status"
      sx={{
        position: "fixed",
        left: "50%",
        bottom: 16,
        transform: "translateX(-50%)",
        zIndex: (theme) => theme.zIndex.snackbar,
        width: "calc(100% - 32px)",
        maxWidth: 560,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        py: 1.25,
        borderRadius: 2,
        bgcolor: BRAND_BLUE_DARK,
        color: "#ffffff",
        boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
      }}
    >
      <Typography variant="body2" sx={{ flex: 1 }}>
        {t("updateBanner.message")}
      </Typography>
      <Button
        size="small"
        variant="contained"
        onClick={() => window.location.reload()}
        sx={{ bgcolor: "#ffffff", color: BRAND_BLUE_DARK, fontWeight: 600, "&:hover": { bgcolor: "#e8eef7" } }}
      >
        {t("updateBanner.refresh")}
      </Button>
      <IconButton size="small" aria-label={t("updateBanner.close")} onClick={() => setDismissed(true)} sx={{ color: "#ffffff" }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}

export default UpdateBanner;
